module.exports = __webpack_public_path__ + "img/图片1.343d8689.png";